import React, { useContext } from "react";
import Render from "../pages/canvas/paper/render";
import DND from "../pages/canvas/paper/dndhandler";

export default React.forwardRef(function Page(props) {
  return (
    <div style={{ position: "relative", height: "100%" }} ref={props.editorRef}>
      <div
        style={{
          display: "flex",
          justifyContent: props.block.props.justifyContent,
          backgroundColor: props.block.props.backgroundColor,
        }}
      >
        {props.children.map((block, index) => {
          const path = [];
          path.push(index);

          return (
            <DND key={block.id} block={block} path={path} index={index}>
              <Render />
            </DND>
          );
        })}
      </div>
      {/* <div style={{ padding: 10, display: "flex", justifyContent: "center" }}>
        <div
          style={{
            border: "2px dashed #E0E0E0",
            fontFamily: "var(--font)",
            borderRadius: 5,
            padding: 12,
            textAlign: "center",
            width: "100%",
          }}
        >
          Drop New Element Here
        </div>
      </div> */}
    </div>
  );
});
